let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("RpbII")).then(() => parcelRequire('4Zoc6'));